import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Paper, Box, Typography, Alert, AlertTitle } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import Button from '@mui/material/Button';
import InfoIcon from '@mui/icons-material/Info';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

import _ from 'lodash';

const steps = [
  { value: 0, label: '기본 정보', color: 'info' },
  { value: 1, label: '파일 관리', color: 'error' },
  { value: 2, label: '담당자 관리', color: 'success' },
];

const requiredFiles = [
  { label: '사업자등록증', uploaded: false },
  { label: '통장사본', uploaded: false },
  { label: '신용평가서', uploaded: false },
];

const PartnerGuideInfo = () => {
  //처음 마운트 될 때 partenr 데이터 요청
  const dispatch = useDispatch();
  const { partner, files, employees } = useSelector(({ partnerModule }) => ({
    partner: partnerModule.partner.partner,
    files: partnerModule.partnerFiles.files,
    employees: partnerModule.partnerEmployees.employees,
  }));
  const [allUploaded, setAllUploaded] = useState(false);

  useEffect(() => {
    if (files) {
      // eslint-disable-next-line array-callback-return
      files.map((file) => {
        // eslint-disable-next-line array-callback-return
        requiredFiles.map((item) => {
          if (!item.uploaded) {
            if (file.fileAttrVal2 === item.label) {
              item.uploaded = true;
            }
          }
        });
      });

      let notUploaded = _.filter(requiredFiles, (item) => !item.uploaded);
      if (notUploaded.length === 0) {
        setAllUploaded(true);
      }
    }
  }, [partner, files]);

  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Paper sx={{ my: 1, p: 1 }} variant="outlined">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          px: 2,
          py: 1,
          '& *': {
            mx: 1,
          },
          backgroundColor: '#424242',
          color: '#fff',
        }}
      >
        <InfoIcon />
        <Typography variant="subtitle2" component="div">
          거래처 가이드
        </Typography>
        <Typography variant="body2" component="div">
          거래처 관리 가이드
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          my: 1,
          '& *': {
            mx: 1,
          },
        }}
      >
        {activeStep === 0 && (
          <>
            <Alert severity="info">
              <AlertTitle>기본 정보</AlertTitle>
              <Typography variant="body2" component="div">
                기본 정보 폼을 입력하세요.
              </Typography>
            </Alert>
            <Box>
              {!partner?.partnerTyp && (
                <Typography variant="body2" component="div">
                  거래처 종류를 선택하세요
                </Typography>
              )}
              {!partner?.partnerNm && (
                <Typography variant="body2" component="div">
                  거래처명을 입력하세요
                </Typography>
              )}
              {!partner?.incTyp && (
                <Typography variant="body2" component="div">
                  산업체 유형을 선택하세요
                </Typography>
              )}
              {!partner?.regNumber && (
                <Typography variant="body2" component="div">
                  사업자번호를 입력하세요
                </Typography>
              )}
              {!partner?.partnerPhone && (
                <Typography variant="body2" component="div">
                  연락처를 입력하세요
                </Typography>
              )}
              {!partner?.partnerAddr && (
                <Typography variant="body2" component="div">
                  주소를 입력하세요
                </Typography>
              )}
              {partner?.partnerTyp &&
                partner?.partnerNm &&
                partner?.regNumber &&
                partner?.partnerPhone &&
                partner?.partnerAddr && (
                  <>
                    <Typography variant="body2" component="div">
                      거래처 기본사항이 모두 입력되어 있습니다.
                    </Typography>
                    <Typography variant="body2" component="div">
                      다음단계 이동을 검토하세요.
                    </Typography>
                  </>
                )}
            </Box>
          </>
        )}
        {activeStep === 1 && (
          <>
            <Alert severity="error">
              <AlertTitle>파일 관리</AlertTitle>
              <Typography variant="body2" component="div">
                거래처 관련 파일을 업로드하세요.
              </Typography>
            </Alert>
            <Box>
              {files.length === 0 ? (
                <Box>
                  <Typography variant="body2" component="div">
                    업로드된 파일이 없습니다
                  </Typography>
                  <Typography variant="body2" component="div">
                    사업자등록증, 통장사본, 신용평가서 등을 업로드하세요.
                  </Typography>
                </Box>
              ) : (
                <>
                  {allUploaded ? (
                    <Box>
                      <Typography variant="body2" component="div">
                        거래처 파일이 모두 업로드되어 있습니다.
                      </Typography>
                      <Typography variant="body2" component="div">
                        다음단계 이동을 검토하세요.
                      </Typography>
                    </Box>
                  ) : (
                    <>
                      {requiredFiles.map((item, index) => {
                        if (!item.uploaded) {
                          return (
                            <div key={index}>
                              <Typography variant="body2" component="div">
                                {item.label} 업로드되지 않았습니다
                              </Typography>
                            </div>
                          );
                        }
                      })}
                    </>
                  )}
                </>
              )}
            </Box>
          </>
        )}
        {activeStep === 2 && (
          <>
            <Alert severity="success">
              <AlertTitle>담당자 관리</AlertTitle>
              <Typography variant="body2" component="div">
                거래처 담당자 정보를 관리하세요.
              </Typography>
            </Alert>
            <Box>
              {employees.length === 0 ? (
                <Box>
                  <Typography variant="body2" component="div">
                    등록된 담당자가 없습니다.
                  </Typography>
                  <Typography variant="body2" component="div">
                    담당자 정보를 등록하세요.
                  </Typography>
                </Box>
              ) : (
                <Box>
                  <Typography variant="body2" component="div">
                    거래처 담당자가 등록되어 있습니다.
                  </Typography>
                  <Typography variant="body2" component="div">
                    다음단계 이동을 검토하세요.
                  </Typography>
                </Box>
              )}
            </Box>
          </>
        )}
      </Box>
      <MobileStepper
        variant="dots"
        steps={steps.length}
        position="static"
        activeStep={activeStep}
        sx={{ flexGrow: 1, borderTop: 1, borderColor: 'divider' }}
        nextButton={
          <Button size="small" onClick={handleNext} disabled={activeStep === 2}>
            {steps[activeStep + 1]?.label}
            {theme.direction === 'rtl' ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            뒤로
          </Button>
        }
      />
    </Paper>
  );
};

export default PartnerGuideInfo;
